import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import {  IVisaGatewayDetails } from "../visagatewayModel";

export const getAllVisaGateway = createAsyncThunk(
  "VisaGateway/FindAllVisaGateway",
  async () => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaGateway/FindAllVisaGateway`,
        {
          VisaType: "",
        }
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching VisaGateway:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const createVisaGateway = createAsyncThunk(
  "VisaGateway/InsertVisaGateway",
  async (VisaGatewayData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaGateway/InsertVisaGateway`,
        VisaGatewayData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating VisaGateway:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateVisaGateway = createAsyncThunk(
  "VisaGateway/UpdateVisaGateway",
  async (VisaGatewayData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaGateway/UpdateVisaGateway`,
        VisaGatewayData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating Visa Gateway:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteVisaGateway = createAsyncThunk(
  "VisaGateway/DeleteVisaGateway",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaGateway/DeleteVisaGateway`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting Visa Gateway", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
export const getVisaGatewayByID = createAsyncThunk(
  "VisaGateway/FindByIDVisaGateway",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaGateway/FindByIDVisaGateway`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        VisaType: result?.VisaType,
        CountryID: result?.CountryID,
        Image: result?.Image,
        IsActive: result?.IsActive ? 1 : 2,
      } as IVisaGatewayDetails;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching Visa Gateway:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveVisaGateway = createAsyncThunk(
  "VisaGateway/FindAllActiveVisaGateway",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/VisaGateway/FindAllActiveVisaGateway`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching  Visa Gateway:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveVisaGateway = createAsyncThunk(
  "VisaGateway/ActiveInActiveVisaGateway",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaGateway/ActiveInActiveVisaGateway`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive Visa Gateway", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const VisaGatewayImageUpload = createAsyncThunk(
  "VisaGateway/VisaGatewayImageUpdate",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/VisaGateway/VisaGatewayImageUpdate`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error upload Visa Gateway Image :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
